export enum RouteName {
    login = 'Login',
    teacher_login = 'Teacher Login',
    study = 'Study'
}